var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { ThemeProvider as ThemeProviderMUI, Experimental_CssVarsProvider as CssVarsProvider, experimental_extendTheme as extendTheme, } from '@mui/material/styles';
import { StyledEngineProvider } from '@mui/material/styles';
import { lightTheme } from './theme';
import { primary, secondary, error, neutral } from './colors';
import { colorMapper } from './color-mapper';
export const CustomThemeProvider = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    const theme = extendTheme({
        colorSchemes: {
            light: {
                palette: {
                    primary: colorMapper(primary),
                    secondary: colorMapper(secondary),
                    error: colorMapper(error),
                    grey: colorMapper(neutral),
                    mcdYellow: '#FFC425',
                },
            },
        },
    });
    return (_jsx(CssVarsProvider, { theme: theme, children: _jsx(ThemeProviderMUI, Object.assign({ theme: lightTheme }, props, { children: _jsx(StyledEngineProvider, { injectFirst: true, children: children }) })) }));
};
export default CustomThemeProvider;
